webpackJsonp([237133482396098],{

/***/ 533:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _LoreHookActions = __webpack_require__(26);
	
	var _LoreHookActions2 = _interopRequireDefault(_LoreHookActions);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _LoreHookActions2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Purpose'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This hook creates the set of default actions for every model.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'To learn more about the behavior of this hook, see the ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/actions/' },
	        'Actions documentation'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Config'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'To learn more about the configuration options for this hook, see the documentation for ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/anatomy/config/actions/' },
	        'config/actions.js'
	      ),
	      '.'
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-hooks-lore-hook-actions-index-js-ff7a9670181a73ef8261.js